import React, {useState, useEffect, createRef, useContext} from 'react'

import { NavigationContext } from './NavigationController'
import Button from './Button'
import DialogBox from './DialogBox'
import Image from './Image'

import { makeStyles, createStyles } from '@material-ui/core/styles'
import { Typography, Box, LinearProgress } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => createStyles({
  boxUpload: {
    border: '2px dashed black'
  },
  spacingText: {
    margin: '4px 0'
  },
  muted: {
    color: '#888'
  }
}));

const ImageUploader = ({ accept, fieldName, recommendedImageSize = '800 x 800px', performUpload, onSave, onClose, ...props}) => {
  const classes = useStyles()  
  const navigationContext = useContext(NavigationContext)  

  const uploadZone = createRef();

  const [tempResult, setTempResult] = useState(null)
  const [uploading, setUploading] = useState(false)

  useEffect(() => {
    window.addEventListener('dragenter', () => console.log('Drag In'))
    window.addEventListener('dragleave', () => console.log('Drag Leave'))
    window.addEventListener('dragover', dragOverEvent)
    window.addEventListener('drop', dropEvent)
    return () => {
      window.removeEventListener('dragenter', () => console.log('Drag In'))
      window.removeEventListener('dragleave', () => console.log('Drag In'))
      window.removeEventListener('dragover', dragOverEvent)
      window.removeEventListener('drop', dropEvent)
    }
  }, [])

  const dragOverEvent = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const dropEvent = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      let fileName = e.dataTransfer.files ? e.dataTransfer.files[0].name : ''
      setUploading(true)
      performUpload(fieldName, e.dataTransfer.files)
      .then(value => {
        if(value !== undefined) {
          let newValue = {
            ...value,
            file_name: fileName
          }

          setUploading(false)
          setTempResult([newValue])
        } else {
          alert("Upload Image Error");
        }
      })
      e.dataTransfer.clearData()
    }
  }

  let actionButtons = [
    <Button color='primary' onClick={() => onSave(tempResult)}>
      Save
    </Button>,
    <Button color='muted' onClick={onClose}>
      Cancel
    </Button>,
  ]

  return (    
    <DialogBox show={ true } onClose={ onClose } actionButtons={actionButtons}>
      <div ref={uploadZone}>
        <Box mt={2}>
          <Box 
            width='100%' p={8} 
            display='flex' className={classes.boxUpload}
            flexDirection='column' alignItems='center' justifyContent='center'
            >
              <Typography variant='body1' className={classes.spacingText}>
                Drag a file Here
              </Typography>
              <Typography variant='body1' className={classes.spacingText}>
                or
              </Typography>
              <Box mt={0.5} mb={0.5}>
                <input 
                  accept={accept} 
                  style={{display: 'none'}} 
                  id="perform_upload" 
                  type="file" 
                  onChange={(e) => {
                    let fileName = e.target.files ? e.target.files[0].name : ''
                    setUploading(true)
                    performUpload(fieldName, e.target.files).then(value => {
                      if(value !== undefined) {
                        setTimeout(() => {
                          let newValue = {
                            ...value,
                            file_name: fileName
                          }
                          setUploading(false)
                          setTempResult([newValue])
                        }, 500)
                      } else {
                        throw new Error("Upload Logo Error");
                      }
                    })
                  }}/>
                <label htmlFor={'perform_upload'}>
                  <Button variant='contained' component='span'>
                    Browse file
                  </Button>
                </label>
              </Box>
          </Box>
          <Box mt={2} mb={2} display='flex' alignItems='center' justifyContent='center'>
            <Typography variant='body1'>
              Recommended Size : {recommendedImageSize}
            </Typography>
          </Box>

          { tempResult && tempResult.length > 0 && tempResult.map(item => 
            <Box display='flex' justifyContent='center' alignItems='center'>
              <Box width='100%' maxWidth='10%' mr={1}>
                <Image src={item.image_url} aspectRatio={1}/>
              </Box>
              <Box flexGrow={1} ml={1}>
                <LinearProgress variant="determinate" value={100} />
                <Box mt={1}>
                  <Typography variant='body1'>{item.file_name || ''}</Typography>
                  <Typography variant='body2' className={classes.muted}>100% Completed</Typography>
                </Box>
              </Box>
            </Box>
          )}

          { uploading &&
            <>
              <Box mt={2} display='flex' justifyContent='center' alignItems='center'>
                <Typography variant='body2'>Uploading.....</Typography>
              </Box>
              <LinearProgress />
            </>
          }
        </Box>
      </div>
    </DialogBox>
  )
}

export default ImageUploader